export const VUE_ENV = process.env.NODE_ENV;
const DEV_URL = 'http://localhost:8082/';
const PRODUCTION_URL = '/api-keys';

export const API_URL: string = VUE_ENV === 'development' ? DEV_URL : PRODUCTION_URL;
